import { render, staticRenderFns } from "./FormSurvey.vue?vue&type=template&id=00bc9e6a&scoped=true"
import script from "./FormSurvey.vue?vue&type=script&lang=js"
export * from "./FormSurvey.vue?vue&type=script&lang=js"
import style0 from "./FormSurvey.vue?vue&type=style&index=0&id=00bc9e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc9e6a",
  null
  
)

export default component.exports